import { createContext, type Dispatch, type SetStateAction, use } from 'react';

import { type DictionaryEnumDto } from '@/api/generated/models/dictionary-enum-dto';
import { type VacancyProjectStatusDto } from '@/api/generated/models/vacancy-project-status-dto';
import { type SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { emptyFunction } from '@/utils/emptyFunction.util.ts';

export type DictionariesContext = {
  assessmentCompanySizesOptions: SelectSearchOptionModel<number>[];
  certificateCategoriesOptions: SelectSearchOptionModel<number>[];
  certificatesOptions: SelectSearchOptionModel<number>[];
  currenciesOptions: SelectSearchOptionModel<number>[];
  industryOptions: SelectSearchOptionModel<number>[];
  languagesOptions: SelectSearchOptionModel<number>[];
  locationsOptions: SelectSearchOptionModel<number>[];
  offeringsCategoriesOptions: SelectSearchOptionModel<number>[];
  offeringsOptions: SelectSearchOptionModel<number>[];
  skillCategoriesOptions: SelectSearchOptionModel<number>[];
  skillsOptions: SelectSearchOptionModel<number>[];
};

export type DictionariesContextProps = DictionariesContext & {
  dictionaryEnums: DictionaryEnumDto[];
  setGroupedDictionaries: Dispatch<SetStateAction<DictionariesContext>>;
  vacancyProjectStatuses: SelectSearchOptionModel<VacancyProjectStatusDto>[];
};

export const DefaultValues: DictionariesContextProps = {
  assessmentCompanySizesOptions: [],
  certificateCategoriesOptions: [],
  certificatesOptions: [],
  currenciesOptions: [],
  dictionaryEnums: [],
  industryOptions: [],
  languagesOptions: [],
  locationsOptions: [],
  offeringsCategoriesOptions: [],
  offeringsOptions: [],
  setGroupedDictionaries: emptyFunction,
  skillCategoriesOptions: [],
  skillsOptions: [],
  vacancyProjectStatuses: [],
};
export const DictionariesContext = createContext<DictionariesContextProps>(DefaultValues);

export const useDictionariesContext = (): DictionariesContextProps => {
  return use<DictionariesContextProps>(DictionariesContext);
};
